module.exports = __webpack_public_path__ + "img/login-img.4edddd50.png";